export default __webpack_public_path__ + "static/media/button-more.e74c2dba.svg";